export const rentalReportKeys = {
    all: () => ['rental-report'] as const,
    report: (startDate: string, endDate: string) =>
        ['rental-report', 'report', startDate, endDate] as const,
}
